import { useCallback } from "react"
import { useFetcher } from "react-router"

import type { EnhancedConfigData } from "./brand-lenses-configuration"
import { SharedFeaturesTab, type FeaturesConfig } from "../shared/SharedFeaturesTab"

export function FeaturesTab({ data, config }: { data: EnhancedConfigData; config: FeaturesConfig }) {
  const fetcher = useFetcher<{ success?: boolean; action?: string; errorMessage?: string }>()

  const isFetching = fetcher.state !== "idle"
  const currentAction = isFetching
    ? ((fetcher.json as { action?: "SAVE_SECTION" | "REMOVE_SECTION" } | undefined)?.action ?? null)
    : null

  const handleSave = useCallback(
    (newFeatureStates: FeaturesConfig) => {
      fetcher.submit(
        {
          action: "SAVE_SECTION",
          organisation: data.loadedOrganisation,
          project: data.loadedProject,
          jsonPath: "$.features",
          value: newFeatureStates as Record<string, string>,
          concurrency: data.existingConfig?.concurrency ?? "",
        },
        { method: "post", encType: "application/json" },
      )
    },
    [fetcher, data],
  )

  const handleRemove = useCallback(() => {
    fetcher.submit(
      {
        action: "REMOVE_SECTION",
        organisation: data.loadedOrganisation,
        project: data.loadedProject,
        jsonPath: "$.features",
        concurrency: data.existingConfig?.concurrency ?? "",
      },
      { method: "post", encType: "application/json" },
    )
  }, [fetcher, data])

  return (
    <SharedFeaturesTab
      config={config}
      onSave={handleSave}
      onRemove={handleRemove}
      isFetching={isFetching}
      currentAction={currentAction}
    />
  )
}
